<template>
  <div class="row">

    <div class="col-12 mb-3" v-if="type === 'ENT' || type === 'SAI'">
      <lazy-select
        label="Empresas:"
        :multiple="true"
        v-model="data.companies"
        resourceName="companies"
        :feminine="true"
        :refSize="4"
        optionLabel="person.name"
      ></lazy-select>
    </div>

    <div class="col-12 mb-3" v-if="type === 'ENT' || type === 'SAI'">
      <lazy-select
        label="Armazéns:"
        :multiple="true"
        v-model="data.stockLocales"
        resourceName="stock-locales"
        :refSize="3"
      ></lazy-select>
    </div>

    <div class="col-12 mb-3" v-if="type === 'ENT' || type === 'SAI'">
      <lazy-select
        label="Operações:"
        :multiple="true"
        v-model="data.fiscalOperations"
        resourceName="fiscal-operations"
        :refSize="4"
        optionLabel="description"
      ></lazy-select>
    </div>
    <div class="col-12">
      <label for="deployment-date">Data de implantação:</label>
      <input
        id="deployment-date"
        type="date"
        class="form-control"
        v-model="data.deploymentDate"
      />
    </div>

  </div>
</template>

<script>
  import { LoadingAnimation } from '@/components/loaders';
  import { MultiListSelect } from 'vue-search-select'
  import LazySelect from '@/components/forms/lazy-select'

  export default {
    name: 'pending-separation-filters',
    components: { LoadingAnimation, MultiListSelect, LazySelect },

    props: {
      data: {
        type: Object,
        require
      },
      type: {
        type: String
      }
    },

    data() {
      return {
      }
    },

    mounted() {
    },

    methods: {
    }
  }
</script>

<style scoped>
</style>
